import { ageLevel, formatDateTime, relativeAge } from "../util/format";

export default function DataAgeBadge({ fetchedAt, prefix }: { fetchedAt: string | null | undefined; prefix?: string }) {
    const level = ageLevel(fetchedAt);
    return (
        <span className={`age-badge ${level}`} title={formatDateTime(fetchedAt)}>
            <span className={`status-dot ${level}`} />
            {prefix ? `${prefix} ` : ""}
            {relativeAge(fetchedAt)}
        </span>
    );
}
